<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="6" v-if="configuration.length">
        <div
          class="kt-portlet kt-portlet--solid-brand kt-portlet--height-fluid"
        >
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-cogwheel"></i>
              </span>
              <h3 class="kt-portlet__head-title">{{ $t("Configuration") }}</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row class="align-items-start justify-content-start">
                <b-col
                  col
                  v-for="(item, index) in configuration"
                  v-bind:key="index"
                  style="min-width: 230px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-font-light btn-outline-hover-light
                      text-left text-nowrap
                      w-100
                    "
                  >
                    <i class="iicon mr-3" :class="item.icon"></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" v-if="products.length">
        <div
          class="kt-portlet kt-portlet--solid-warning kt-portlet--height-fluid"
        >
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-presentation-1"></i>
              </span>
              <h3 class="kt-portlet__head-title">{{ $t("Products") }}</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col
                  col
                  v-for="(item, index) in products"
                  v-bind:key="index"
                  style="min-width: 260px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-font-dark btn-outline-hover-dark
                      text-nowrap text-left
                      w-100
                    "
                  >
                    <i
                      class="iicon mr-3"
                      style="color: #282a3c"
                      :class="item.icon"
                    ></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" v-if="platformReports.length">
        <div
          class="kt-portlet kt-portlet--solid-danger kt-portlet--height-fluid"
        >
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-pie-chart"></i>
              </span>
              <h3 class="kt-portlet__head-title">
                {{ $t("Platform Reports") }}
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col
                  col
                  v-for="(item, index) in platformReports"
                  v-bind:key="index"
                  style="min-width: 300px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-font-light btn-outline-hover-light
                      text-nowrap text-left
                      w-100
                    "
                  >
                    <i class="iicon mr-3" :class="item.icon"></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" v-if="reports.length">
        <div
          class="kt-portlet kt-portlet--solid-success kt-portlet--height-fluid"
        >
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-time-1"></i>
              </span>
              <h3 class="kt-portlet__head-title">{{ $t("Reports") }}</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col
                  col
                  v-for="(item, index) in reports"
                  v-bind:key="index"
                  style="min-width: 300px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-font-light btn-outline-hover-light
                      text-nowrap text-left
                      w-100
                    "
                  >
                    <i class="iicon mr-3" :class="item.icon"></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" v-if="financialReports.length">
        <div class="kt-portlet kt-portlet--solid-info kt-portlet--height-fluid">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-diagram"></i>
              </span>
              <h3 class="kt-portlet__head-title">
                {{ $t("Financial Reports") }}
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col
                  col
                  v-for="(item, index) in financialReports"
                  v-bind:key="index"
                  style="min-width: 300px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-font-light btn-outline-hover-light
                      text-nowrap text-left
                      w-100
                    "
                  >
                    <i class="iicon mr-3" :class="item.icon"></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" v-if="jackpots.length">
        <div
          class="kt-portlet kt-portlet--solid-brand kt-portlet--height-fluid"
        >
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="icon-diamond"></i>
              </span>
              <h3 class="kt-portlet__head-title">{{ $t("Jackpots") }}</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col
                  col
                  v-for="(item, index) in jackpots"
                  v-bind:key="index"
                  style="min-width: 300px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-font-light btn-outline-hover-light
                      text-nowrap text-left
                      w-100
                    "
                  >
                    <i class="iicon mr-3" :class="item.icon"></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" v-if="admin.length">
        <div
          class="
            kt-portlet kt-portlet--solid-secondary kt-portlet--height-fluid
          "
        >
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-diagram"></i>
              </span>
              <h3 class="kt-portlet__head-title">{{ $t("Administration") }}</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col
                  col
                  v-for="(item, index) in admin"
                  v-bind:key="index"
                  style="min-width: 300px"
                  class="flex-grow-0"
                >
                  <router-link
                    :to="item.url"
                    class="
                      btn btn-outline-hover-dark
                      text-nowrap text-left
                      w-100
                    "
                  >
                    <i class="iicon secondary mr-3" :class="item.icon"></i>
                    {{ $t(item.name) }}
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
      <!--b-col cols="12" md="6">
        <div class="kt-portlet kt-portlet--solid-danger kt-portlet--height-fluid">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="flaticon-map"></i>
              </span>
              <h3 class="kt-portlet__head-title">{{$t('Test')}}</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-portlet__content">
              <b-row>
                <b-col col style="min-width: 300px" class="flex-grow-0">
                  <router-link
                    to="/external-content/api"
                    class="btn btn-font-light btn-outline-hover-light text-nowrap text-left w-100"
                  >
                    <i class="iicon mr-3 flaticon-map"></i>
                    API
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col-->
    </b-row>
  </div>
</template>

<script>
import idToRole from "@/store/ui-permissions/routerPermissions.js";

export default {
  created() {
    const self = this;
    const items = this.$store.getters["uiPermissions/navItems"];
    items.forEach((element) => {
      if (element.id == "home") return;
      const tmp = JSON.parse(JSON.stringify(element));

      if (typeof element.children != "undefined") {
        element.children.forEach((el) => {
          const tmp = JSON.parse(JSON.stringify(el));
          if (typeof idToRole[tmp.id] != "undefined") {
            const role = idToRole[tmp.id];
            if (!role.ignore) {
              if (!this.$ability.can(role.action, role.subject)) {
                return;
              }
            }

            tmp.color = self.getRandomColor();
            self[tmp.category].push(tmp);
            self.links.push(tmp);
          }
        });
      } else {
        if (typeof idToRole[tmp.id] != "undefined") {
          const role = idToRole[tmp.id];
          if (!role.ignore) {
            if (!this.$ability.can(role.action, role.subject)) {
              return;
            }
          }

          tmp.color = self.getRandomColor();
          self[tmp.category].push(tmp);
          self.links.push(tmp);
        }
      }
    });
  },
  data() {
    return {
      colors: ["primary", "success", "info", "warning", "danger", "secondary"],
      links: [],
      configuration: [],
      products: [],
      reports: [],
      platformReports: [],
      financialReports: [],
      jackpots: [],
      admin: [],
      index: 0,
    };
  },
  methods: {
    getRandomColor() {
      if (this.index >= this.colors.length) {
        this.index = 0;
      }
      const color = this.colors[this.index];
      this.index++;
      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.iicon {
  font-size: 20px;
  color: #fff;
}

.iicon.bg-secondary {
  color: #000;
}
.iicon.secondary {
  color: #000;
}
</style>
